import { Shield } from "lucide-react"

export function SafetyDisclaimer() {
  return (
    <div className="mt-6 flex gap-3 rounded-xl border border-amber-200/80 bg-amber-50/90 p-4 text-sm text-amber-950">
      <Shield className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" aria-hidden />
      <p>
        Not emergency or medical advice. If you&apos;re worried about {`your dog's`} health or
        safety, contact your veterinarian.
      </p>
    </div>
  )
}
